export { default as EquipmentLoaderWrapper } from './equipment-loader-wrapper';
